import React from 'react';
import AccountBalanceWallet from '@mui/icons-material/AccountBalanceWallet';
import Assignment from '@mui/icons-material/Assignment';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircle from '@mui/icons-material/CheckCircle';
import HourglassTop from '@mui/icons-material/HourglassTop';
import MarkEmailUnread from '@mui/icons-material/MarkEmailUnread';
import Paid from '@mui/icons-material/Paid';
import Plagiarism from '@mui/icons-material/Plagiarism';
import Warning from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';

export const statusToSpanish = (ready = false) => {
  const { t } = useTranslation();
  const commonStatuses = {
    CREATED: 'Disponible',
    PROCESSING: t('Processing invoice'),
    REJECTED: 'Cesión rechazada',
    PENDINGRATIFICATION: 'Por ratificar',
    PENDINGDOCUMENTSREVIEW: 'Revisando documentos',
    REJECTEDRATIFICATION: 'Ratificación rechazada',
    REJECTEDDOCUMENTS: 'Documentos rechazados',
    REJECTEDPREOFFEREVALUATION: 'Eval. de preoferta rechazada',
    PENDINGDOCUMENTSEXPIRED: 'Expirada en pendiente de documentos',
    PENDINGDOCUMENTS: 'Pendiente documentos',
    PENDINGTRANSFER: 'En curse',
    REJECTEDTRANSFER: 'Depósito rechazado',
    TRANSFERED: 'Por cobrar',
    DEBT: 'En mora',
    PARTIALCOLLECTION: 'Recaudación parcial',
    PROROGUED: 'Prorrogada',
    EVALUATING: 'En evaluación',
    FINISHED: 'Recaudada',
    SURPLUSWITHDRAWN: 'Recaudada. Con Excedentes',
    LOANEDOTHER: 'Cedida',
    BADDEBT: 'Incobrable',
    EXPIRED: 'Expirada',
    RECEDED: 'Recedida',
  };

  const readyStatuses = {
    ...commonStatuses,
    PROCESSING: t('Processing completed'),
    PENDINGRATIFICATION: 'Ratificada',
    PENDINGDOCUMENTSREVIEW: 'Documentos revisados',
    PENDINGTRANSFER: 'Girado',
  };

  return ready ? readyStatuses : commonStatuses;
};

export const statusToIcon = {
  CREATED: <AssignmentTurnedIn />,
  PROCESSING: <Assignment />,
  REJECTED: <Warning />,
  REJECTEDPREOFFEREVALUATION: <Warning />,
  PENDINGDOCUMENTSEXPIRED: <Warning />,
  PENDINGRATIFICATION: <MarkEmailUnread />,
  PENDINGDOCUMENTSREVIEW: <Plagiarism />,
  REJECTEDRATIFICATION: <Warning />,
  REJECTEDDOCUMENTS: <Warning />,
  PENDINGTRANSFER: <AccountBalanceWallet />,
  PENDINGDOCUMENTS: <AccountBalanceWallet />,
  REJECTEDTRANSFER: <Warning />,
  TRANSFERED: <Paid />,
  DEBT: <Warning />,
  PARTIALCOLLECTION: <Paid />,
  EVALUATING: <HourglassTop />,
  FINISHED: <CheckCircle />,
  SURPLUSWITHDRAWN: <CheckCircle />,
  LOANEDOTHER: <Warning />,
  BADDEBT: <Warning />,
  EXPIRED: <Warning />,
  RECEDED: <Warning />,
};

export const statusToActiveStep = {
  PROCESSING: 0,
  REJECTED: 0,
  REJECTEDPREOFFEREVALUATION: 0,
  PENDINGDOCUMENTSEXPIRED: 0,
  PENDINGRATIFICATION: 1,
  PENDINGDOCUMENTSREVIEW: 1,
  REJECTEDTRANSFER: 1,
  PENDINGDOCUMENTS: 1,
  REJECTEDRATIFICATION: 1,
  REJECTEDDOCUMENTS: 1,
  PENDINGTRANSFER: 2,
  TRANSFERED: 3,
  DEBT: 3,
  PARTIALCOLLECTION: 3,
  PROROGUED: 3,
  FINISHED: 3,
  EXPIRED: 3,
};

export const statusToColor = {
  PROCESSING: 'gold',
  REJECTED: 'red',
  REJECTEDPREOFFEREVALUATION: 'red',
  PENDINGDOCUMENTSEXPIRED: 'red',
  PENDINGRATIFICATION: 'gold',
  PENDINGDOCUMENTSREVIEW: 'gold',
  REJECTEDRATIFICATION: 'red',
  REJECTEDDOCUMENTS: 'red',
  PENDINGTRANSFER: 'gold',
  PENDINGDOCUMENTS: 'gold',
  REJECTEDTRANSFER: 'red',
  TRANSFERED: 'green',
  DEBT: 'red',
  PARTIALCOLLECTION: 'green',
  PROROGUED: 'green',
  FINISHED: 'green',
  EXPIRED: 'gold',
};

export const statusToStepLabels = (status) => {
  let labels = [statusToSpanish()[status]];
  if (statusToActiveStep[status] === 0) {
    labels = labels.concat(['Ratificación', 'Depósito', 'Recaudación']);
  }
  if (statusToActiveStep[status] === 1) {
    labels.unshift(['Cedida']);
    labels = labels.concat(['Depósito', 'Recaudación']);
  }
  if (statusToActiveStep[status] === 2) {
    labels.unshift('Cedida', 'Ratificada');
    labels.push('Recaudación');
  }
  if (statusToActiveStep[status] === 3) {
    labels.unshift('Cedida', 'Ratificada', 'Depositada');
  }
  return labels;
};
